import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';
import type { CropMonitoringNote, CropMonitoringNoteInput } from '/@/types/crop-monitoring-note';

const BASE = () => `${settings.urls.apiDomain}/core/v1/crop-monitoring/notes`;

export interface CropMonitoringNoteFilters {
    field?: number;
    plantingDateCropMonitoring?: number;
    applicationRegister?: number;
    applicationReportResult?: number;
    cornYieldEstimation?: number;
    closedCropMonitoring?: number;
    /** Created date >= (inclusive, by day). Format: YYYY-MM-DD. */
    createdGte?: string;
    /** Created date <= (inclusive, by day). Format: YYYY-MM-DD. */
    createdLte?: string;
    ordering?: string;
    page?: number;
    pageSize?: number;
}

export interface Paginated<T> {
    count: number;
    results: T[];
}

export async function getCropMonitoringNotes(
    filters: CropMonitoringNoteFilters = {}
): Promise<Paginated<CropMonitoringNote>> {
    const params = new URLSearchParams();
    if (filters.field !== undefined) params.append('field', String(filters.field));
    if (filters.plantingDateCropMonitoring !== undefined)
        params.append('planting_date_crop_monitoring', String(filters.plantingDateCropMonitoring));
    if (filters.applicationRegister !== undefined)
        params.append('application_register', String(filters.applicationRegister));
    if (filters.applicationReportResult !== undefined)
        params.append('application_report_result', String(filters.applicationReportResult));
    if (filters.cornYieldEstimation !== undefined)
        params.append('corn_yield_estimation', String(filters.cornYieldEstimation));
    if (filters.closedCropMonitoring !== undefined)
        params.append('closed_crop_monitoring', String(filters.closedCropMonitoring));
    if (filters.createdGte) params.append('created__gte', filters.createdGte);
    if (filters.createdLte) params.append('created__lte', filters.createdLte);
    if (filters.ordering) params.append('ordering', filters.ordering);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.pageSize) params.append('page_size', String(filters.pageSize));

    const res = await axFetch.get(`${BASE()}/?${params.toString()}`);
    return res.data;
}

export const getCropMonitoringNoteById = async (id: number): Promise<CropMonitoringNote> => {
    const res = await axFetch.get(`${BASE()}/${id}/`);
    return res.data;
};

export const createCropMonitoringNote = async (data: CropMonitoringNoteInput): Promise<CropMonitoringNote> => {
    const res = await axFetch.post(`${BASE()}/`, data);
    return res.data;
};

export const updateCropMonitoringNote = async (
    id: number,
    data: CropMonitoringNoteInput
): Promise<CropMonitoringNote> => {
    const res = await axFetch.patch(`${BASE()}/${id}/`, data);
    return res.data;
};

export const deleteCropMonitoringNote = async (id: number): Promise<void> => {
    await axFetch.delete(`${BASE()}/${id}/`);
};
